import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _RootAccountSharing;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyleOverrides, CAN_EDIT, READ_ONLY, SimpleSelect } from '@instructure/quiz-common';
import { IconAdminLine } from '@instructure/ui-icons';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import { Grid } from '@instructure/ui-grid';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
export var RootAccountSharing = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_RootAccountSharing = /*#__PURE__*/function (_Component) {
  function RootAccountSharing() {
    var _this;
    _classCallCheck(this, RootAccountSharing);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RootAccountSharing, [].concat(args));
    _defineProperty(_this, "isSharedWithAccount", function () {
      return [READ_ONLY, CAN_EDIT].includes(_this.props.accountPermission);
    });
    return _this;
  }
  _inherits(RootAccountSharing, _Component);
  return _createClass(RootAccountSharing, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(View, {
        as: "div",
        margin: "0 0 medium 0"
      }, /*#__PURE__*/React.createElement(Grid, {
        colSpacing: "small"
      }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Col, {
        width: "auto"
      }, /*#__PURE__*/React.createElement(IconAdminLine, {
        size: "medium"
      })), /*#__PURE__*/React.createElement(Grid.Col, null, /*#__PURE__*/React.createElement(View, {
        as: "div",
        padding: "0 0 x-small 0"
      }, this.props.accountName), /*#__PURE__*/React.createElement(Checkbox, {
        label: t('Share with Institution'),
        variant: "toggle",
        value: "accountPermission",
        checked: this.isSharedWithAccount(),
        onChange: this.props.onShareChange,
        "data-automation": "sdk-share-bank-with-institution-toggle"
      })), this.isSharedWithAccount() && /*#__PURE__*/React.createElement(Grid.Col, {
        width: "auto"
      }, /*#__PURE__*/React.createElement(SimpleSelect, {
        onChange: this.props.onShareTypeChange,
        value: this.props.accountPermission,
        renderLabel: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Access for account'))
      }, /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "sharing-modal-account-perm-select-option-can-view",
        value: READ_ONLY
      }, t('Can view')), /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "sharing-modal-account-perm-select-option-can-edit",
        value: CAN_EDIT
      }, t('Can edit')))))));
    }
  }]);
}(Component), _defineProperty(_RootAccountSharing, "displayName", 'RootAccountSharing'), _defineProperty(_RootAccountSharing, "componentId", "Quizzes".concat(_RootAccountSharing.displayName)), _defineProperty(_RootAccountSharing, "propTypes", {
  accountName: PropTypes.string,
  onShareChange: PropTypes.func.isRequired,
  onShareTypeChange: PropTypes.func.isRequired,
  accountPermission: PropTypes.string
}), _defineProperty(_RootAccountSharing, "defaultProps", {
  accountName: t('Account'),
  accountPermission: null
}), _RootAccountSharing)) || _class);
export default RootAccountSharing;